import React from "react";
import { useNoIndex } from "@/lib/usePageSeo";
import { Link } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { LogIn } from "lucide-react";

export default function AdminLoginPage() {
  useNoIndex();
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/auth-callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0F0F0F] grid place-items-center px-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-10">
          <Logo size="lg" />
        </div>
        <div className="ur-card p-8 text-center">
          <div className="ur-eyebrow">Admin Access</div>
          <h1 className="font-display mt-3 text-3xl font-black">CMS Dashboard</h1>
          <p className="mt-3 text-sm text-[#A3A3A3]">
            Sign in with your Google account to manage services, projects, laptops and software.
          </p>
          <button
            data-testid="admin-google-login"
            onClick={handleLogin}
            className="ur-btn-primary w-full mt-7"
          >
            Sign in with Google <LogIn className="w-4 h-4" />
          </button>
          <Link to="/" className="block mt-5 text-xs text-[#A3A3A3] hover:text-[#FF6600]">
            ← Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
